import React, { useState } from 'react'
import { Panel } from 'rsuite'
import { isEmpty } from 'lodash'
import { useForm, Controller } from 'react-hook-form'
import {
  deleteDocument,
  downloadDocument,
  renameDocument,
  seveSummaryNote,
  uploadDocuments,
} from '../../redux/actions/proposeConsiderApproveProject'
import { startLoading, doneLoading } from '../../utils/loading'
import AttachFilesForm from '../attachfiles/AttachFilesForm'
import AttachFilesView from '../attachfiles/AttachFilesView'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'
import ProposeConsiderApproveSummaryNoteForm from './ProposeConsiderApproveSummaryNoteForm'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'

export default function ProposeConsiderApproveProjectUploadWidget({
  schema: _schema,
  showCommandButton,
}) {
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [deleteError, setDeleteError] = useState()
  const [renameError, setRenameError] = useState()

  const handleCallUploadFiles = async (request) => {
    startLoading()
    setIsLoading(true)
    setError()
    try {
      const response = await uploadDocuments(projectId, request)
      setFormSchema((state) => {
        const allFiles = response.model?.fileList?.value || []
        return {
          ...state,
          fileList: {
            ...state.fileList,
            value: allFiles,
          },
        }
      })
      setError(false)
    } catch (e) {
      setError('อัปโหลดไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallDeleteFiles = async (request) => {
    startLoading()
    setIsLoading(true)
    setDeleteError(false)
    try {
      const response = await deleteDocument(projectId, request)
      setFormSchema((state) => {
        const allFiles = response.model?.fileList?.value || []
        return {
          ...state,
          fileList: {
            ...state.fileList,
            value: allFiles,
          },
        }
      })
    } catch (e) {
      setDeleteError('ลบไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallRenameFile = async (request) => {
    startLoading()
    setIsLoading(true)
    setRenameError()
    try {
      const response = await renameDocument(projectId, request)
      setFormSchema((state) => {
        const updatedFile = state.fileList.value.map((item) => {
          if (item.id === request.id) {
            return response.model
          }
          return item
        })
        return {
          ...state,
          fileList: {
            ...state.fileList,
            value: updatedFile,
          },
        }
      })
      setRenameError(false)
    } catch (e) {
      setRenameError('แก้ไขชื่อไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    try {
      const file = await downloadDocument(projectId, fileObj.id)
      previewFile(file, fileObj.name)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onDownload = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    try {
      const file = await downloadDocument(projectId, fileObj.id)
      downloadFile(file, fileObj.name)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmitSummaryNote = async (request) => {
    startLoading()
    setIsLoading(true)
    try {
      const result = await seveSummaryNote(projectId, request)
      if (result?.model?.success) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: result?.model?.message || DEFAULT_ERR_MSG,
        })
      }
    } catch (err) {
      notification.open('error', {
        title: err?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnClickUpload = (filesData) => {
    if (isEmpty(filesData?.attachFiles)) {
      return
    }

    const formData = new FormData()
    filesData?.attachFiles.forEach((element) => {
      formData.append('files', element.blobFile)
    })
    handleCallUploadFiles(formData)
  }

  const handleOnClickDelete = (fileIndex) => {
    if (!formSchema?.fileList?.value?.[fileIndex]?.id) {
      return
    }
    const request = {
      id: formSchema.fileList.value[fileIndex].id,
      fileName: formSchema.fileList.value[fileIndex].name,
    }
    handleCallDeleteFiles(request)
  }

  const handleOnClickRenameFile = (file, newName) => {
    if (!newName) {
      return
    }
    const request = {
      id: file.id,
      fileName: newName,
      fileLabel: newName,
    }
    handleCallRenameFile(request)
  }

  const handleSubmitSummaryNote = (data) => {
    // console.log('data : ', data)

    let req = {
      summaryNote: data[formSchema.summaryNote.name],
    }

    onSubmitSummaryNote(req)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel header={formSchema?.header} collapsible defaultExpanded bordered shaded>
        {/* <UploadWithTableListForm
          fileList={schema?.fileList}
          onClickUpload={handleOnClickUpload}
          onClickDelete={handleOnClickDelete}
          loading={isLoading}
          error={error}
          deleteError={deleteError}
          hideUploader={!showCommandButton}
          hideDelete={!showCommandButton}
        /> */}

        <ProposeConsiderApproveSummaryNoteForm
          schema={formSchema.summaryNote}
          showCommandButton={!formSchema?.summaryNote?.disabled && showCommandButton}
          onSubmit={handleSubmitSummaryNote}
        />

        {formSchema.summaryNote && <hr />}

        {showCommandButton ? (
          <>
            <AttachFilesForm
              schema={formSchema?.fileList}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              onSubmit={handleSubmit(handleOnClickUpload)}
              onDelete={handleOnClickDelete}
              onUpdate={handleOnClickRenameFile}
              onDownload={onDownload}
              onPreview={onPreview}
              isChangSeqNo={false}
              isEditErr={renameError}
              isUploadErr={error}
              isDeleteError={deleteError}
              loading={isLoading}
              buttonText="เอกสารแนบ"
            />
          </>
        ) : (
          <>
            <AttachFilesView
              schema={formSchema?.fileList}
              onDownload={onDownload}
              onPreview={onPreview}
            />
          </>
        )}
      </Panel>
    </>
  )
}
